import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";
import { PanicAlertTopicRequest } from "./panic-alert-topic-request";
import { LoadPersonRequest } from "./load-person-request";

@Injectable()
export class DataService_TopicMaintenance {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	PanicAlertTopicSelectList(SchoolID: number) {
		var postResult$ = new Subject();
		var url = "PortalApps/PanicAlertTopicSelectList?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	PanicAlertTopicInsert(parms: PanicAlertTopicRequest) {
		var postResult$ = new Subject();
		var url = "PortalApps/PanicAlertTopicInsert";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	PanicAlertTopicUpdate(parms: PanicAlertTopicRequest) {
		var postResult$ = new Subject();
		var url = "PortalApps/PanicAlertTopicUpdate";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	PanicAlertTopicToggle(PortalPanicAlertTopicID: number, Active: number) {
		var postResult$ = new Subject();
		var url = "PortalApps/PanicAlertTopicToggle?PortalPanicAlertTopicID=" + PortalPanicAlertTopicID + "&Active=" + Active;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	PanicAlertTopicDelete(PortalPanicAlertTopicID: number) {
		var postResult$ = new Subject();
		var url = "PortalApps/PanicAlertTopicDelete?PortalPanicAlertTopicID=" + PortalPanicAlertTopicID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	PanicAlertTopicPersonSelectList(PortalPanicAlertTopicID: number) {
		var postResult$ = new Subject();
		var url = "PortalApps/PanicAlertTopicPersonSelectList?PortalPanicAlertTopicID=" + PortalPanicAlertTopicID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	PanicAlertTopicAssign(parms: PanicAlertTopicRequest) {
		var postResult$ = new Subject();
		var url = "PortalApps/PanicAlertTopicAssign";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	PanicAlertTopicUnassign(parms: PanicAlertTopicRequest) {
		var postResult$ = new Subject();
		var url = "PortalApps/PanicAlertTopicUnassign";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	AssignPersonSelectList(parms: LoadPersonRequest) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/AssignPersonSelectList";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
